const AppConfig = {
  soft_id: "chat_deepseek_win",
  // soft_id: "abcchat_win",
  os: 1,
  curr_ver: `1.0.0.0`,
};

export { AppConfig };
